export default __webpack_public_path__ + "static/media/ivLogo.6fc7d897.svg";